/* global G */
import { modelComposition } from 'trait/composition'
import { pipe } from 'lib/util'
import { usesGetterSetter } from 'trait/uses'
import toInt from 'model/_shared/transformer/toInt'
import toString from 'model/_shared/transformer/toString'
import validator from 'model/xEcoApm/validator/licence'
import { withGetterSetter } from 'trait/with'

const descriptor = 'model::xEcoApm::licence'

export default pipe(
  modelComposition(descriptor),
  withGetterSetter(G.VALIDATOR),
  usesGetterSetter(G.VALIDATOR, validator),
  usesGetterSetter(G.TRANSFORMER, {
    // value
    serial: toString('serial'),
    duration: toInt('duration'),
  }),
)
